"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _r10CommonComponents = require("r10-common-components");
var _activePlanSection = _interopRequireDefault(require("./activePlanSection"));
var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));
var _useConfig = _interopRequireDefault(require("../hooks/useConfig"));
var _planActions = require("../actions/planActions");
var _selectors = require("../selectors");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  height: ", "px;\n  ", "\n  & .margin-auto {\n    margin: auto;\n  }\n"])), function (props) {
  return props !== null && props !== void 0 && props.wrapperHeight ? props.wrapperHeight : 240;
}, _r10SourceLibrary.Mixins.respondTo.md((0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      height: ", "px;\n    "])), function (props) {
  return props !== null && props !== void 0 && props.wrapperHeight ? props.wrapperHeight : 288;
})));
var App = function App() {
  var isLoading = (0, _reactRedux.useSelector)(_selectors.isLoadingSelector);
  var hasError = (0, _reactRedux.useSelector)(_selectors.hasErrorSelector);
  var t = (0, _useTranslation.default)();
  var config = (0, _useConfig.default)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var getActivePlanDetails = function getActivePlanDetails() {
    dispatch((0, _planActions.getActivePlanDetailsRequest)());
  };
  (0, _react.useEffect)(function () {
    var _Object$keys;
    if (((_Object$keys = Object.keys(config)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0) {
      getActivePlanDetails();
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (config === null || config === void 0 ? void 0 : config.isTitleShown) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    weight: 3,
    text: t('planTitle')
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    paddingLevel: 3,
    appearance: "primary",
    elevation: true,
    dataAttributes: {
      'data-testid': 'plan-container'
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Grid, null, isLoading && !hasError && /*#__PURE__*/_react.default.createElement(Wrapper, {
    "data-testid": "plan-card-loader",
    wrapperHeight: config === null || config === void 0 ? void 0 : config.wrapperHeight
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Loader, {
    text: t('loading'),
    size: 2,
    srText: "Loading"
  })), hasError && !isLoading && /*#__PURE__*/_react.default.createElement(Wrapper, {
    wrapperHeight: config === null || config === void 0 ? void 0 : config.wrapperHeight
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    align: "center",
    justify: "center",
    disableFlex: true,
    className: "margin-auto"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: "auto"
  }, /*#__PURE__*/_react.default.createElement(_r10CommonComponents.ErrorContent, {
    icon: "clock",
    title: t('timeOut'),
    description: t('timeoutErrorMessage'),
    buttonText: t('retryActionButtonText'),
    titleTestId: "plan-card-timeout-title",
    descriptionTestId: "plan-card-timeout-description",
    actionButtonTestId: "plan-card-retryButton",
    iconSize: 1,
    buttonAction: getActivePlanDetails
  })))), !isLoading && !hasError && /*#__PURE__*/_react.default.createElement(_activePlanSection.default, null))));
};
var _default = App;
exports.default = _default;